import lottie from 'lottie-web';
import React, { useEffect, useRef } from 'react';

const TableAnimation = () => {
    const container = useRef(null);

    useEffect(() => {
        const animation = lottie.loadAnimation({
            container: container.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/animation/data-scanning.json'
        });

        return () => animation.destroy();
    }, []);

    return <div className='svg-animation-loader' ref={container} />;
};

export default TableAnimation;
